export const RESOLUTION_30MP = 6720;
export const RESOLUTION_480P = 720;
export const RESOLUTION_720P = 1200;
export const RESOLUTION_1080P = 1920;
export const VIEWER_MODE_PORTRAIT = "portrait";
export const VIEWER_MODE_LANDSCAPE = "landscape";
export const VIEWER_MODE_BOUNDING_BOX = "bounding-box";
